module.exports = __webpack_public_path__ + "img/oblong-bg.3eb2700b.png";